import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";
import Spinner from "../spinner/spinner";

const LoadingInput = ({
  value,
  onChange,
  disabled,
  isLoading,
  type = "text",
  style = {},
  placeholder = "",
  as = "input",
  options = [],
  ...props
}) => {
  const inputProps = {
    type,
    value,
    onChange,
    disabled: disabled || isLoading,
    style: {
      ...style,
      paddingRight: isLoading
        ? "40px"
        : as === "select"
        ? "30px"
        : style.paddingRight,
    },
    placeholder,
    ...props,
  };

  return (
    <div className="position-relative d-flex align-items-center w-100">
      {as === "select" ? (
        <>
          <Form.Select {...inputProps}>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
          {isLoading && (
            <div
              style={{
                position: "absolute",
                right: "30px",
                pointerEvents: "none",
              }}
            >
              <Spinner size="sm" />
            </div>
          )}
        </>
      ) : (
        <>
          <Form.Control as={as === "textarea" ? "textarea" : undefined} {...inputProps} />
          {isLoading && (
            <div
              style={{
                position: "absolute",
                right: "10px",
                pointerEvents: "none",
              }}
            >
              <Spinner size="sm" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

LoadingInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  type: PropTypes.string,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  as: PropTypes.oneOf(["input", "select", "textarea"]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
};

export default LoadingInput;
